module.exports = __webpack_public_path__ + "ab.no1.241ee5ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/ab.no1.jpg
// module id = QthW
// module chunks = 0